<template>
  <div>
    <v-row>
      <template v-if="masterData.active_version != '0.0.0'">
        <v-col>
          <div class="d-flex">
            <strong> 現在のバージョン </strong>
            <p class="ml-2">
              {{ masterData.active_version }}
            </p>
          </div>
        </v-col>
        <v-col>
          <div class="d-flex">
            <strong style="min-width: 80px !important"> 公開日 </strong>
            <p class="ml-2 min-width-2" v-if="masterData.approved_at">
              {{ $moment(masterData.approved_at).format('YYYY/MM/DD HH:mm') }}
            </p>
          </div>
        </v-col>
      </template>
      <strong class="pt-3" v-else>現在のバージョン：未公開</strong>
      <v-spacer />
      <!-- Dialog confirm releast date beta -->
      <!-- <v-dialog v-model="dialogComfirmReleastBeta" persistent max-width="370">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            small
            class="mr-3 my-2"
            v-if="appNote"
            v-bind="attrs"
            v-on="on"
            >本番からデータをコピーする</v-btn
          >
        </template>
        <v-card>
          <v-card-title class="headline"> 確認 </v-card-title>
          <v-card-text class="pb-0"
            >検証環境にリリースします。よろしいですか。</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              small
              @click="releaseBeta"
              :loading="loadingRelaseBeta"
              :disabled="loadingRelaseBeta"
              >OK</v-btn
            >
            <v-btn color @click="dialogComfirmReleastBeta = false" small
              >キャンセル</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog> -->
      <!-- Dialog confirm releast -->
      <v-dialog v-model="dialogComfirm" persistent max-width="370">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            small
            class="mr-0 my-2"
            :disabled="
              masterData.release !== 'PENDING' || loadingRelase || (!selectDataSelfStudy && selected.length == 0)
            "
            v-bind="attrs"
            v-on="on"
            >リリース依頼</v-btn
          >
        </template>
        <v-card>
          <v-card-title class="headline"> 確認 </v-card-title>
          <v-card-text class="pb-0">リリース依頼します。よろしいですか</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" small @click="release" :loading="loadingRelase" :disabled="loadingRelase">OK</v-btn>
            <v-btn color @click="dialogComfirm = false" small>キャンセル</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="updateData"
        :items-per-page.sync="pagination.maxResultCount"
        :page="pagination.page"
        hide-default-header
        :loading="loadingData"
        loading-text="読み込み中。。。待ってください。"
        hide-default-footer
        item-key="name"
        :show-select="masterData.release == 'PENDING'"
        show-expand
        class="elevation-1 width-10"
      >
        <template v-slot:top>
          <div class="header-top">
            <v-checkbox
              v-if="masterData.release == 'PENDING' && updateData.length > 0"
              class="my-0 mt-2 ml-4"
              v-model="selectAllUpdateData"
            ></v-checkbox>
            <div class="text-center width-10">
              <strong>ストーリーモード</strong>
            </div>
          </div>
        </template>
        <template v-slot:expanded-item="{ item }">
          <td colspan="2">
            <v-row class="my-2" no-gutters v-for="(itemChil, inx) in item.data" :key="inx">
              <v-col cols="3">{{ convertDataUpdate(itemChil.updateData).updateKey }}</v-col>
              <v-col>{{ convertDataUpdate(itemChil.updateData).text }}</v-col>
            </v-row>
          </td>
        </template>
        <template v-slot:no-data>データがありません。</template>
      </v-data-table>
    </v-row>
    <v-row>
      <v-spacer />
      <BasePagination
        class="mt-2"
        v-if="updateData && updateData.length > 0"
        :pageCount="updateData && updateData.length"
        :pageSize="pagination.maxResultCount"
        @changePage="changePage"
      />
    </v-row>
    <v-row class="mt-5">
      <v-data-table
        :headers="headersSelfStudy"
        :items="updateDataSelfStudy"
        :items-per-page.sync="paginationSelfStudy.maxResultCount"
        :page="paginationSelfStudy.page"
        hide-default-header
        :loading="loadingData"
        loading-text="読み込み中。。。待ってください。"
        single-select
        hide-default-footer
        class="elevation-1 width-10"
      >
        <template v-slot:top>
          <div class="header-top">
            <v-checkbox
              v-if="masterData.release == 'PENDING' && updateDataSelfStudy.length > 0"
              class="my-0 mt-2 ml-4"
              v-model="selectDataSelfStudy"
            ></v-checkbox>
            <div class="text-center width-10">
              <strong>自習</strong>
            </div>
          </div>
        </template>
        <template v-slot:item.name="{ item }">
          {{ convertDataSelfStudy(item).updateKey }}
        </template>
        <template v-slot:item.text="{ item }">
          {{ convertDataSelfStudy(item).text }}
        </template>
        <template v-slot:no-data>データがありません。</template>
      </v-data-table>
    </v-row>
    <v-row>
      <v-spacer />
      <BasePagination
        class="mt-2"
        v-if="updateDataSelfStudy && updateDataSelfStudy.length > 0"
        :pageCount="updateDataSelfStudy && updateDataSelfStudy.length"
        :pageSize="paginationSelfStudy.maxResultCount"
        @changePage="changePageSelfStudy"
      />
    </v-row>
  </div>
</template>
<script>
import mixin from '@/mixin';
import BasePagination from '@/components/Pagination/BasePagination';
import { getMasterData } from '@/api/MasterData.api';
import { releastBeta } from '@/api/Season.api';
import { exportData } from '@/api/Season.api';
import { restoreStatus } from '@/api/Mobile.api';
export default {
  mixins: [mixin.App],
  store: ['restoreStatus'],
  components: {
    BasePagination,
  },
  data() {
    return {
      masterData: {},
      loadingData: false,
      loadingRelase: false,
      loadingRelaseBeta: false,
      dialogComfirm: false,
      dialogComfirmReleastBeta: false,
      selectAllUpdateData: false,
      selectDataSelfStudy: false,
      selected: [],
      headers: [
        {
          value: 'name',
          groupable: false,
        },
        { text: '', value: 'data-table-expand', align: 'end' },
      ],
      headersSelfStudy: [
        {
          value: 'name',
          groupable: false,
        },
        { text: '', value: 'text' },
      ],
      paginationSelfStudy: {
        page: 1,
        pageCount: 0,
        maxResultCount: 12,
      },
    };
  },
  mounted() {
    this.getMasterData();
  },
  computed: {
    appNote() {
      return process.env.VUE_APP_NOTE == 'LOCAL' || process.env.VUE_APP_NOTE == 'STAGING' ? true : false;
    },
    updateData() {
      const {
        masterData: { data },
      } = this;
      return data;
    },
    updateDataSelfStudy() {
      const {
        masterData: { data_self_study },
      } = this;

      return data_self_study;
    },
  },
  watch: {
    selectAllUpdateData: function (val) {
      if (val) {
        this.selected = this.updateData;
      } else {
        this.selectAllUpdateData = false;
        this.selectDataSelfStudy = false;
        this.selected = [];
      }
    },
  },
  methods: {
    async release() {
      const { Id } = this.masterData;
      const { selected, selectDataSelfStudy } = this;
      this.loadingRelase = true;
      let params = {
        id: Id,
        array_select_section: selected,
        release_self_status: selectDataSelfStudy,
      };
      await exportData(params).then(async () => {
        await this.getMasterData();
        this.loadingRelase = false;
        this.dialogComfirm = false;
        this.selected = [];
        this.selectDataSelfStudy = false;
      });
    },
    async releaseBeta() {
      this.loadingRelaseBeta = true;
      await releastBeta();
      await restoreStatus().then(({ result }) => {
        console.log('result: ', result);
      });
      this.restoreStatus = true;
      this.loadingRelaseBeta = false;
      this.dialogComfirmReleastBeta = false;
    },
    changePage(value) {
      this.pagination.page = value;
    },
    changePageSelfStudy(value) {
      this.paginationSelfStudy.page = value;
    },
    async getMasterData() {
      this.loadingData = true;
      await getMasterData().then(({ result }) => {
        this.masterData = result;
      });
      this.loadingData = false;
    },
    convertDataSelfStudy(data) {
      const {
        category,
        datetime,
        tab,
        vocabulary,
        badge,
        grammar,
        question,
        data: { type },
      } = data;
      let text;
      let updateKey;
      // Update category
      if (category && category != 'NULL' && category != 'NUL') {
        updateKey = 'カテゴリ';
        text = 'カテゴリが変更される';
      }
      // Update tab
      else if (tab && tab != 'NULL') {
        updateKey = 'タブ';
        text = 'タブが変更される';
      }
      // Update question
      else if (question && question != 'NULL' && question != 'NUL') {
        updateKey = '練習問題';
        text = '練習問題が変更される';
      }
      // Update vocabulary
      else if (vocabulary && vocabulary != 'NULL') {
        updateKey = '単語帳';
        text = '単語帳が変更される';
      }
      // Update badge
      else if (badge && badge != 'NULL') {
        updateKey = '単語帳のバッヂ';
        text = '単語帳のバッヂが変更される';
      }
      // Update grammar
      else if (grammar && grammar != 'NULL') {
        updateKey = '文法解説';
        text = '文法解説が変更される';
      }
      // Update hour
      else if (datetime && datetime != 'NULL' && (type == 'HOUR' || type == 'MINUTE')) {
        updateKey = '時間';
        text = '時間が変更される';
      }
      // Update week
      else if (datetime && datetime != 'NULL' && (type == 'WEEK' || type == 'DAY' || type == 'MONTH')) {
        updateKey = '日付';
        text = '日付が変更される';
      }

      return { text, updateKey };
    },
    convertDataUpdate(data) {
      const { _ } = this;
      let text;
      let updateKey;
      // var name = "";
      _.forIn(data, function (value, key) {
        if (!_.isEmpty(value)) {
          // conversation
          if (key == 'conversation') {
            updateKey = 'スキット';
            text = 'スキットが変更される';
          }
          // question
          else if (key == 'question') {
            updateKey = '練習問題';
            text = '練習問題が変更される';
          }
          // grammar
          else if (key == 'grammar') {
            updateKey = '文法解説';
            // _.forEach(value.data, function (i) {
            //   if (i.key == "Title") {
            //     name += i.value.ja;
            //   }
            // });
            text = `文法解説が変更される`;
          }
          // expression
          else if (key == 'expression') {
            updateKey = '表現・文型';
            console.log('value: ', value);
            // _.forEach(value.data, (e) => {
            //   console.log("e: ",e)
            //   if (e.key == "FormTitle") {
            //     _.forEach(e.data, (i) => {
            //       console.log("i: ",i)
            //       if (i.key == "Title") {
            //         name += i.value.ja;
            //       }
            //     });
            //   }
            // });
            text = `表現・文型が変更される`;
          }
          // question
          else if (key == 'question') {
            updateKey = '練習問題';
            text = `練習問題が変更される`;
          } else if (key == 'info') {
            if (value['title']) {
              updateKey = 'シーンタイトル';
              text = 'シーンタイトルが変更される';
            } else if (value['titleKana']) {
              updateKey = 'シーンタイトル（かな）';
              text = 'シーンタイトル（かな）が変更される';
            } else if (value['goal']) {
              updateKey = '学習目標';
              text = '学習目標が変更される';
            } else if (value['lead_sentence']) {
              updateKey = 'リード文';
              text = 'リード文が変更される';
            }
          }
        }
      });
      return { text, updateKey };
    },
  },
};
</script>
<style scoped>
strong {
  min-width: 130px;
}
::v-deep td:not(:last-child),
th:not(:last-child) {
  border-right: none !important;
}
::v-deep .v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: none;
}
::v-deep tr.v-data-table__expanded.v-data-table__expanded__row {
  background: #eeeeee;
}
.header-top {
  display: flex;
  /* justify-content: center; */
  min-height: 40px;
  align-items: center;
  border-bottom: 1px solid #cccccc;
  background: #e0e0e0;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.header-top strong {
  text-align: center;
}
::v-deep .v-input__slot {
  margin-bottom: 0;
}
</style>
